import { DeleteOutlineRounded } from "@mui/icons-material";
import React from "react";
import {
  TableCell as MuiTableCell,
  TableContainer,
  Table as MuiTable,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  Button,
} from "@mui/material";
import stylesTable from "../../styles/Molecules/Table/table";
import { useTranslation } from "react-i18next";
import "../../Traduccion_ES_EN/i18nMiCuenta";



function TableLine({
  data,
  columnTitles,
  cellComponent,
  showActionColumn,
  actionColumnTitle,
  actionColumnLabel,
  onActionClick,
  showDeleteColumn,
  showDeleteButton,
  handleDeleteClick,
}) 

{
  //#region Traduccion
  const { t } = useTranslation();


  if (!Array.isArray(data)) {
    return <p style={{fontFamily: 'Raleway, sans-serif', fontSize:"14px"}}>{t("Welcome.text61")}</p>;
    }
    

  return (
    <div>
      {data ? (
        <TableContainer>
          <MuiTable style={stylesTable.table}>
            <TableHead>
              <TableRow>
                {columnTitles.map((title, index) => (
                  <MuiTableCell key={index} style={stylesTable.title}>
                    {title}
                  </MuiTableCell>
                ))}
                {showActionColumn && (
                  <MuiTableCell style={stylesTable.title}>
                    {actionColumnTitle}
                  </MuiTableCell>
                )}
                {showDeleteColumn && (
                  <MuiTableCell style={stylesTable.title}>
                    {t("Welcome.text119")}
                  </MuiTableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((tableItem, index) => (
                <TableRow  key={index}
                style={{
                  backgroundColor:"white"
                }}>
                  {columnTitles.map((title, columnIndex) => (
                    <MuiTableCell style={{...stylesTable.column,
                      fontFamily: "Raleway, sans-serif",}} key={columnIndex}>
                      {cellComponent(tableItem, title)}
                    </MuiTableCell>
                  ))}
                   {showActionColumn && (
                  <MuiTableCell style={{ textAlign: "center" }}>
                    <a
                      style={stylesTable.a}
                      href="#"
                      onClick={(e) => onActionClick(tableItem, e)}
                    >
                      {actionColumnLabel}
                    </a>
                  </MuiTableCell>
                )}
                  {showDeleteColumn && (
                    <MuiTableCell style={{ textAlign: "center" }}>
                       {showDeleteButton ? (
                      <Button
                        style={{
                          borderRadius: "20px",
                          backgroundColor: "#9f0202",
                          color: "white",
                          padding: "8px 16px",
                          height:"25px"
                        }}
                        onClick={() => handleDeleteClick(tableItem)}
                      >
                        {t("Welcome.text140")}
                      </Button>
                       ) : (
                        <DeleteOutlineRounded
                          style={stylesTable.icon}
                          onClick={() => handleDeleteClick(tableItem)}
                        />
                      )}
                    </MuiTableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </MuiTable>
        </TableContainer>
      ) : (
        <p>{t("Welcome.text141")}</p>
      )}
    </div>
  );
}

export default TableLine;
